/**
 * Waits for a work order to finish and hands it back — for the screens that send a question to the
 * agent and show its answer (a prompt review, a question about a session).
 */

import { useQuery } from '@tanstack/react-query'
import { api } from './api'
import type { WorkOrder } from './types'

export function useOrderResult(orderId: string | null) {
  const { data } = useQuery({
    queryKey: ['work-order', orderId],
    queryFn: async () => (await api.workOrders.list()).find((o) => o.id === orderId) ?? null,
    enabled: Boolean(orderId),
    refetchInterval: (query) => {
      const order = query.state.data as WorkOrder | null | undefined
      return order && order.status !== 'Running' ? false : 3_000
    },
  })
  const order = data ?? null
  return { order, finished: Boolean(order && order.status !== 'Running') }
}
